import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { TextHighlighter, SuggestDesktopList, SuggestionDesktopDefaultItem } from '../../components';
import { DropdownPopover } from '../../../../popover';
import { useIconMargin, useSuggestSelectedItem } from '../../hooks';
import { SuggestionTitleItem } from '../../components/SuggestionTitleItem';
import { Outside } from '../../../../services';
import { SuggestionTextItem } from '../../components/SuggestionTextItem';
import { SUGGEST_PROP_DEFAULTS } from '../../constants';
import { useMaxLinesCssVarable } from '../../hooks/useMaxLinesCssVarable';
import { useSuggestMouseEvents } from '../../hooks/useSuggestMouseEvents';
var suggestItemComponentMap = {
  default: SuggestionDesktopDefaultItem,
  title: SuggestionTitleItem
};
export var SuggestDesktop = function SuggestDesktop(props) {
  var _props$maxHeight;
  var onSelect = props.onSelect,
    onClose = props.onClose;
  var listBoxRef = React.useRef(null);
  var suggestionsChildrenRef = React.useRef(null);
  useMaxLinesCssVarable({
    ref: listBoxRef,
    maxLines: props.maxLines,
    open: props.open
  });
  var _useSuggestSelectedIt = useSuggestSelectedItem(props, {
      suggestionsChildrenRef: suggestionsChildrenRef,
      listBoxRef: listBoxRef
    }),
    setSelectedItemIndex = _useSuggestSelectedIt.setSelectedItemIndex,
    selectedItemIndex = _useSuggestSelectedIt.selectedItemIndex;
  var mouseEventProps = useSuggestMouseEvents(setSelectedItemIndex);
  var _useIconMargin = useIconMargin(props.suggestions),
    getIconMarginForItem = _useIconMargin.getIconMarginForItem,
    setTitleItemRefByIndex = _useIconMargin.setTitleItemRefByIndex;
  var onItemClick = React.useCallback(function (item, index) {
    return function () {
      setSelectedItemIndex(index);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(item, {
        source: 'click'
      });
    };
  }, [setSelectedItemIndex, onSelect]);
  var onOutsideClick = React.useCallback(function () {
    return onClose === null || onClose === void 0 ? void 0 : onClose({
      source: 'outsideClick'
    });
  }, [onClose]);
  var insideRefs = React.useMemo(function () {
    return [listBoxRef, suggestionsChildrenRef];
  }, []);
  var isPopupListShown = props.suggestions.length || props.emptyListText;
  var NoItemsComponent = !props.suggestions.length && props.emptyListText && /*#__PURE__*/React.createElement(SuggestionTextItem, null, props.emptyListText);
  return /*#__PURE__*/React.createElement(DropdownPopover, {
    open: props.open,
    sameWidth: "width",
    content: isPopupListShown && /*#__PURE__*/React.createElement(Outside, {
      onOutside: onOutsideClick,
      insideRefs: insideRefs
    }, /*#__PURE__*/React.createElement(SuggestDesktopList, {
      ref: listBoxRef,
      maxHeight: (_props$maxHeight = props.maxHeight) !== null && _props$maxHeight !== void 0 ? _props$maxHeight : SUGGEST_PROP_DEFAULTS.maxHeight
    }, NoItemsComponent, props.suggestions.map(function (suggestion, i) {
      var _suggestion$type;
      var ItemComponent = suggestItemComponentMap[(_suggestion$type = suggestion.type) !== null && _suggestion$type !== void 0 ? _suggestion$type : SUGGEST_PROP_DEFAULTS.itemType];
      return /*#__PURE__*/React.createElement(ItemComponent, _extends({}, suggestion, {
        key: i,
        type: suggestion.type,
        iconMargin: getIconMarginForItem(suggestion),
        ref: suggestion.type === 'title' ? setTitleItemRefByIndex(i) : undefined,
        onMouseMove: mouseEventProps.onMouseMove(i),
        onMouseLeave: mouseEventProps.onMouseLeave,
        onMouseEnter: mouseEventProps.onMouseEnter,
        isSelected: selectedItemIndex === i,
        onClick: onItemClick(suggestion, i),
        variant: "desktop"
      }), /*#__PURE__*/React.createElement(TextHighlighter, {
        highlightValue: props.highlightValue
      }, suggestion.title));
    })))
  }, /*#__PURE__*/React.createElement("div", {
    ref: suggestionsChildrenRef,
    "data-testid": "suggest-children"
  }, props.children));
};
SuggestDesktop.displayName = 'SuggestDesktop';